import { render, staticRenderFns } from "./ParameterEditor.vue?vue&type=template&id=5520483c"
import script from "./ParameterEditor.vue?vue&type=script&lang=js"
export * from "./ParameterEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports